import { Component } from '@angular/core';
import {BaseComponentService} from '../../services/base-component.service';

@Component({
  selector: 'gpa-adm-parametro',
  templateUrl: './adm-parametro.component.html',
  providers: [BaseComponentService]
})

export class AdmParametroComponent extends BaseComponentService{


}



// WEBPACK FOOTER //
// ./src/app/pagamento/adm-pagamento/adm-parametro.component.ts